import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Dialog  from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

import AccountCircle from '@material-ui/icons/AccountCircle'

import logo from './logo.svg'

import { VERSION } from '../constants'

import { detect } from 'detect-browser'
const browser = detect()

const styles = theme => ({
  avatar: { width: 35, height: 35 },
  flex: { flex: 1 },
  logo: { height: 35, marginLeft: -10 },
  root: { flexGrow: 1 },
})

class Header extends React.Component {

  state = {
    anchorEl: null,
    aboutOpen: false
  }

  handleAboutOpen = () => {
    this.setState({ aboutOpen: true })
    this.setState({ anchorEl: null })
  }

  handleAboutClose = e => {
    this.setState({ aboutOpen: false })
  }

  handleMenuOpen = e => {
    this.setState({ anchorEl: e.currentTarget })
  }

  handleMenuClose = e => {
    this.setState({ anchorEl: null })
  }

  handleLogin = () => {
    const { handleLogin } = this.props
    handleLogin()
    this.setState({ anchorEl: null })
  }

  handleLogout = () => {
    const { handleLogout } = this.props
    handleLogout()
    this.setState({ anchorEl: null })
  }

  render() {
    const { classes, isAuthenticated, profile } = this.props
    const { anchorEl } = this.state
    const open = Boolean(anchorEl)
    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar>
            <Link to='/'><img src={logo} alt="Addresscloud" className={classes.logo} /></Link>
            <Typography className={classes.flex}>
            </Typography>
              <IconButton
                aria-owns={open ? 'account-appbar' : null}
                aria-haspopup='true'
                onClick={this.handleMenuOpen}
                color='inherit'>
                { profile ?
                  <Avatar alt={profile.nickname} src={profile.picture}
                    className={classes.avatar} /> :
                  <AccountCircle />
                }
              </IconButton>
              <Menu
                id='account-appbar' anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={open} onClose={this.handleMenuClose}>
                <MenuItem onClick={this.handleAboutOpen}>About</MenuItem>
                { isAuthenticated ?
                  <MenuItem onClick={this.handleLogout}>Logout</MenuItem> :
                  <MenuItem onClick={this.handleLogin}>Login</MenuItem> }
              </Menu>
          </Toolbar>
        </AppBar>
        <Dialog onClose={this.handleAboutClose} open={this.state.aboutOpen}>
          <Card>
            <CardContent>
            <Typography gutterBottom variant="headline" component="h3" align="center">
              About
            </Typography>
            <Typography component="p" align="center">
              Application: Addresscloud<sup>&reg;</sup> Batch <br/>
              Last Updated: {VERSION} (UTC) <br/>
              Operating System: {browser.os} <br/>
              Browser: {browser.name} ({browser.version})
            </Typography>
            </CardContent>
          </Card>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Button size="small" color="primary" onClick={this.handleAboutClose}>OK</Button>
          </div>
        </Dialog>
      </div>
    )
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  handleLogin: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  profile: PropTypes.object.isRequired,
}

export default withStyles(styles)(Header)
